/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Řadit podle`
};

const da_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sorter efter`
};

const de_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sortieren nach`
};

const en_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sort by`
};

const es_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Ordenar por`
};

const fr_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Trier par`
};

const hu_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Rendezés`
};

const it_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Ordina per`
};

const nl_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sorteren op`
};

const pl_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sortuj według`
};

const pt_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Ordenar por`
};

const sv_sort_by = /** @type {(inputs: {}) => string} */ () => {
	return `Sortera efter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sort_by = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sort_by(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sort_by", locale)
	if (locale === "cs") return cs_sort_by(inputs)
	if (locale === "da") return da_sort_by(inputs)
	if (locale === "de") return de_sort_by(inputs)
	if (locale === "en") return en_sort_by(inputs)
	if (locale === "es") return es_sort_by(inputs)
	if (locale === "fr") return fr_sort_by(inputs)
	if (locale === "hu") return hu_sort_by(inputs)
	if (locale === "it") return it_sort_by(inputs)
	if (locale === "nl") return nl_sort_by(inputs)
	if (locale === "pl") return pl_sort_by(inputs)
	if (locale === "pt") return pt_sort_by(inputs)
	return sv_sort_by(inputs)
};